// MENECER TƏSDİQİ — həssas əməliyyat üçün birdəfəlik icazə.
//
// ═══ NİYƏ BU, "MENECER HESABINA GİRMƏK"DƏN YAXŞIDIR ═══
//
// Ofisant mətbəxə getmiş sətri silmək istəyəndə əvvəllər yeganə yol menecerin
// PIN-i ilə TAM GİRİŞ etmək idi. PIN-i bir dəfə görən ofisant sonra menecerin
// bütün səlahiyyətlərinə sahib olurdu və jurnal da menecerin adını yazırdı.
//
// Bu axında ofisant ÖZ hesabında qalır:
//   • menecer yalnız PIN-ini yazır, sessiya AÇILMIR
//   • token 60 saniyə yaşayır, TƏK İSTİFADƏLİKDİR
//   • token məhz həmin əməliyyata və həmin sətrə bağlıdır (scope + context
//     hash) — kopyalayıb başqa yerdə işlətmək mümkün deyil
//   • audit-də HƏR İKİSİ görünür: kim istədi, kim təsdiqlədi
//
// Server tərəfi (`pos_local`) artıq hazır idi; çatışmayan yalnız bu çağırış idi.

import { posRequest } from './posClient';

/** Təsdiq tələb edən əməliyyatlar. Server eyni sətirləri gözləyir. */
export const APPROVAL_SCOPES = {
  /** Mətbəxə göndərildikdən sonra sifariş sətrini silmək. */
  voidItemAfterKitchen: 'orders.voidItem.afterKitchen',
} as const;

export type ApprovalScope = (typeof APPROVAL_SCOPES)[keyof typeof APPROVAL_SCOPES];

export interface ApprovalRequest {
  managerName: string;
  managerPin: string;
  scope: ApprovalScope;
  /**
   * Əməliyyatın konteksti — SERVERDƏ HASH-LANIR və token ona bağlanır.
   * Buradakı açarlar server gözlədiyi ilə HƏRFİ üst-üstə düşməlidir,
   * əks halda `APPROVAL_CONTEXT_MISMATCH` alınır.
   */
  context: Record<string, unknown>;
}

export interface ApprovalGrant {
  token: string;
  expiresAt: number;
}

export class ApprovalError extends Error {
  constructor(
    message: string,
    /** MANAGER_NOT_FOUND | NOT_A_MANAGER | INVALID_CREDENTIALS | USER_LOCKED */
    readonly code: string,
  ) {
    super(message);
  }
}

/**
 * Menecerin PIN-ini yoxlayıb birdəfəlik token alır.
 *
 * Xəta halları ayrıca kodlarla qayıdır ki, ekran doğru mesajı göstərsin:
 * "menecer tapılmadı" ilə "PIN səhvdir" fərqli şeylərdir.
 */
export async function requestManagerApproval(req: ApprovalRequest): Promise<ApprovalGrant> {
  const res = await posRequest<{ token: string; approval: { expiresAt: number } }>({
    method: 'POST',
    path: '/v1/auth/manager-approve',
    body: {
      managerName: req.managerName,
      managerPin: req.managerPin,
      scope: req.scope,
      context: req.context,
    },
  });

  if (!res.ok || !res.data?.token) {
    throw new ApprovalError(
      res.error?.message || 'Təsdiq alınmadı',
      res.error?.code || 'APPROVAL_FAILED',
    );
  }

  return { token: res.data.token, expiresAt: res.data.approval?.expiresAt ?? 0 };
}

/**
 * Serverin "menecer təsdiqi lazımdır" cavabını tanıyır.
 *
 * Gateway pos_local xətasını axios formasına çevirir (bax: adapter.ts),
 * ona görə koda iki yerdə baxırıq.
 */
export function needsManagerApproval(error: unknown): boolean {
  const e = error as {
    posCode?: string;
    response?: { data?: { code?: string; error?: { code?: string } } };
  };
  const code =
    e?.posCode ??
    e?.response?.data?.code ??
    e?.response?.data?.error?.code ??
    '';

  return code === 'APPROVAL_REQUIRED';
}
